<div class="tag-card" [hidden]="hide || !tags.length" #card>
    <div class="tag-card-inner">
        <mat-chip-set class="tag-card-chip-set wrap">
            <mat-chip
                *ngFor="let tag of tags"
                (click)="filterByTag(tag); $event.stopPropagation()"
                class="pointer"
                [style.background]="tag.color"
                [disableRipple]="true"
            >
                {{ tag.name }}
            </mat-chip>
        </mat-chip-set>
    </div>
</div>
